FIRST_DIGIT_OR_ASCII